import React, { Component, useState } from 'react'
import '../BranchMangement/BranchListContainer.css'
import { Input, Container, Row, Col } from 'reactstrap'
import PermissionsList from "./PermissionsList"
import CreatePermissionModal from "./CreatePermissionModal"
import RestrictedSection from "../../Components/RestrictedSection"
import AdvancedFilters from '../../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../../Filters/filterUrl'

// Advanced filters live in the URL (useAdvancedFilters); this control just hosts
// the popover open/close state so the class container can render it.
function PermissionsAdvancedFiltersControl() {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger compact count={advancedFilters.length} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="permission"
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                />
            )}
        </>
    )
}

class PermissionsListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            searchTerm: "",
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_permission">
                <Container fluid className="bos-listing-container">
                    <Row className="align-items-center">
                        <Col xs={4}>
                            <span className="driver-search-filter">
                                <Input type="text" name="searchTerm" placeholder="Search" onChange={this.updateInput} />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col xs="auto" className="p-0">
                            <PermissionsAdvancedFiltersControl />
                        </Col>
                        <Col className="text-right">
                            <a className="driver-list-button" onClick={() => this.toggleModal("createPermission")}>
                                Create Permission | <i className="fa fa-user-plus" aria-hidden="true"></i>
                            </a>
                            {this.state.openModal === "createPermission" && <CreatePermissionModal handleClose={() => this.toggleModal("createPermission")} open={this.state.openModal === "createPermission"} />}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="mt-2 search-filter-container">
                            <AppliedAdvancedFilters entity="permission" context={null} />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            <PermissionsList searchTerm={this.state.searchTerm ? this.state.searchTerm : ""} />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}


export default PermissionsListContainer

